<template>
    <b-modal :id="modalId" :title="$t('forms.imagePickerTitle')" size="xl" header-bg-variant="primary" header-text-variant="light"
             :okTitle="$t('forms.close')" ok-only @show="loadImages">
        <div class="row images">
            <div class="col-lg-1 my-auto text-center p-1" v-for="image in images" :key="image.id"
                 :id="'image-wrapper-' + image.id">
                <img :id="image.id" :src="image.filename" :alt="image.alt" class="browser-image"
                     @click="selectImage(image.id)">
                <b-popover :target="'image-wrapper-' + image.id" triggers="hover" placement="top">
                    <div class="row">
                        <div class="col text-center">
                            <span><em>{{ image.filename.substr(8) }}</em></span><br>
                            <span class="p-0">{{ image.width + ' x ' + image.height }}</span>
                        </div>
                    </div>
                </b-popover>
            </div>
        </div>
    </b-modal>
</template>

<script>
import axios from 'axios'
import {Const} from '@/config'

export default {
    name: 'ImagePickerModal',
    props: {
        modalId: {
            type: String,
            default: 'image-picker'
        }
    },
    data() {
        return {
            images: []
        }
    },
    methods: {
        loadImages() {
            axios.get(Const.API_HOST + '/admin/images')
                .then(response => response.data).then(body => {
                this.images = body
            }).catch(error => {
                // eslint-disable-next-line no-console
                console.error(error)
            })
        },
        selectImage(id) {
            var selected = this.images.find(obj => {
                return obj.id === id
            })

            this.$emit('select', selected)
            this.$bvModal.hide(this.modalId)
        }
    }
}
</script>

<style scoped>
.browser-image {
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
}
</style>
